<section #cal2Start class="lead-hero curve -bottom -white">
    <span class="photo"></span>
    <div class="intro">
        <div class="container">
            <div class="flow">
                <a [routerLink]="['/calculate']">
                    <i class="icon icon-arrow-back"></i>
                    <span class="text">{{language.backcal}}</span>
                </a>
            </div>
            <div class="row">
                <div class="col-xl-7">
                    <h1 class="title insert-dotdotdot" style="overflow-wrap: break-word">{{language.step2topic1}}</h1>
                </div>
            </div>
        </div>
    </div>
</section>

<section class="section section-retirement curve -top -white" *ngIf="isRetire">
    <div class="container">
        <header class="heading-topic text-center">
            <h2 class="topic-title">
                <span rel="border-circle">
                    <i class="icon icon-text-doc"></i>
                </span>
                <span class="text text-left -xs">{{language.step2title1}}</span>
            </h2>
        </header>
        <div class="row">
            <div class="col-lg-5">
                <section class="result">
                    <i class="icon icon-user"></i>
                    <div class="text">
                        <p>{{language.step2t1col1detail1}}
                            <span>{{investmentHorizon}}</span> {{language.step2t1col1detail2}}
                        </p>
                        <p>{{language.step2t1col1detail3}}
                            <span>{{retirementLength}}</span> {{language.step2t1col1detail4}}
                        </p>
                    </div>
                </section>
                <section class="result">
                    <i class="icon icon-coin"></i>
                    <div class="text">
                        <p>{{language.step2t1col2detail1}}
                            <span>{{retiremetExpenses | number}}</span> {{language.step2t1col2detail2}}
                        </p>
                        <p>{{language.step2t1col2detail3}}
                            <span>{{presentValue | number}}</span> {{language.step2t1col2detail4}}
                        </p>
                        <p *ngIf="futureValue != '0'" style="margin-top: 5px;">{{language.step2t1col2detail5}}
                            <span>{{futureValue | number}}</span> {{language.step2t1col2detail6}}
                        </p>
                    </div>
                </section>
            </div>
            <div class="col-lg-7">
                <section class="result">
                    <i class="icon icon-money-bag"></i>
                    <div class="text">
                        <p>{{language.step2t1col3detail1}}
                            <br> {{language.step2t1col3detail2}}
                            <span>{{aom | number}}</span> {{language.step2t1col3detail3}} {{expectedRString}} {{language.step2t1col3detail5}}
                            <br class="d-xl-block"> {{language.step2t1col3detail4}}
                            <span *ngFor="let item of investmentAllocation">
                                <ng-container *ngIf="flag == 'th'">
                                    <span *ngIf="item.valuePercent != 0"
                                        style="font-size: 16px; color:black; font-weight: normal;">
                                        {{item.fundTypeTH}}</span>
                                </ng-container>
                                <ng-container *ngIf="flag == 'en'">
                                    <span *ngIf="item.valuePercent != 0"
                                        style="font-size: 16px; color:black; font-weight: normal;">
                                        {{item.fundType}}</span>
                                </ng-container>
                                <span *ngIf="item.valuePercent != 0"> {{item.valuePercent}}%</span>
                            </span>

                        </p>
                    </div>
                </section>
            </div>
        </div>
    </div>
</section>

<section class="section section-goal curve -top" *ngIf="isRetire">
    <div class="container">
        <header class="heading-topic text-center">
            <h2 class="topic-title">
                <span rel="border-circle">
                    <i class="icon icon-s-piggy"></i>
                </span>
                <span class="text text-left -xs">{{language.step2title2}}</span>
            </h2>
        </header>
        <div class="row">
            <ul class="list list-retirement list-unstyled">

                <li *ngIf="aom=='0'" class="col-md-6 col-lg-3"></li>

                <li class="col-md-6 col-lg-3">
                    <span>{{language.step2t2col1detail1}}</span>
                    <span class="number">{{currentSaving | number}}
                        <small class="unit">{{language.step2t2col1detail2}}</small>
                    </span>
                </li>
                <li class="col-md-6 col-lg-3">
                    <span>{{language.step2t2col2detail1}}</span>
                    <span class="number">{{presentValue | number}}
                        <small class="unit">{{language.step2t2col2detail2}}</small>
                    </span>
                </li>
                <li *ngIf="aom!=='0'" class="col-md-6 col-lg-3">
                    <span>{{language.step2t2col3detail1}}</span>
                    <span class="number">{{aom | number}}
                        <small class="unit">{{language.step2t2col3detail2}}</small>
                    </span>
                </li>
                <li *ngIf="aom!='0'" class="col-md-6 col-lg-3">
                    <span>{{language.step2t2col4detail1}}</span>
                    <span class="number">{{payment | number : '1.0-0'}}
                        <small class="unit">{{language.step2t2col4detail2}}</small>
                    </span>
                </li>

                <li *ngIf="aom=='0'" class="col-md-6 col-lg-3"></li>

            </ul>
        </div>

    </div>
</section>

<section class="section section-form curve -top -white">
    <div class="container">
        <header class="heading-topic text-center">
            <h2 class="topic-title">
                <span rel="border-circle">
                    <i class="icon icon-grow"></i>
                </span>
                <span class="text text-left -xs">{{language.step2title3}}</span>
            </h2>
        </header>
        <div class="row">
            <div class="col-lg-6">
                <div style="width: 100%;">
                    <div id="container" class="pie-chart" [chart]="donut"></div>

                </div>
            </div>
            <div class="col-lg-6">
                <section class="summary summary-recommend">
                    <div class="info">
                        <div class="detail">
                            <p>{{language.step2t3detail1}}
                                <span class="number">{{expectedR}}%</span>
                            </p>
                            <p *ngIf="isGenerald&&generaldInvestment!=='0'">{{language.step2t3detail2}}
                                <span class="number"> {{generaldInvestment | number : '1.0-0'}} </span>
                                {{language.step2t3detail3}}
                            </p>
                        </div>
                        <ul class="list-unstyled list-fund">
                            <li *ngFor="let allo of investmentAllocation; index as i">
                                <ng-container *ngIf="flag == 'th'">
                                    <span *ngIf="allo.valuePercent != 0" class="title-cat-{{i}}">
                                        {{allo.fundTypeTH}} {{allo.valuePercent}}%
                                    </span>
                                </ng-container>
                                <ng-container *ngIf="flag == 'en'">
                                    <span *ngIf="allo.valuePercent != 0" class="title-cat-{{i}}">
                                        {{allo.fundType}} {{allo.valuePercent}}%
                                    </span>
                                </ng-container>
                                <span *ngIf="allo.valuePercent != 0" class="text">{{language.step2t3detail4}}</span>
                                <ul *ngIf="allo.valuePercent != 0" class="list-unstyled list-inline list-feature">
                                    <li *ngFor="let item of allo.fundMapp">
                                        <a [ngClass]="whatClass(item.riskFundTypeId, item.fundNameEn)"
                                            href="fund/detail/{{item.fundid}}/{{item.currency}}"
                                            class="btn btn-primary ">{{item.fundCode}}</a>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </section>
                <section class="remark">
                    <br>
                    <span class="red">*</span><span> {{language.step2remark1}}</span>
                    <br>
                    <br>
                    <span class="blue">*</span><span> {{language.step2remark2}}</span>
                </section>
            </div>
        </div>
    </div>
</section>

<section class="section section-terms curve -top -white">
    <div class="container">
        <header class="heading-topic">
            <h2 class="topic-title">{{language.step2title4}}</h2>
        </header>
        <section class="block-scroll">
            <section class="wrapper" tabindex="1" style="overflow: auto; outline: none">
                <div class="group-section">
                    <h3 class="topic-title sub-title h6">{{language.step2subtitle1}}</h3>
                    <p>{{language.step2subtitle1detail}}
                    </p>
                </div>
                <div class="group-section">
                    <h3 class="topic-title sub-title h6">{{language.step2subtitle2}}</h3>
                    <ol>
                        <li>{{language.step2subtitle2detail1}}
                        </li>
                        <li>
                            {{language.step2subtitle2detail2}}
                        </li>
                        <li>{{language.step2subtitle2detail3}}</li>
                        <li>{{language.step2subtitle2detail4}}</li>
                    </ol>
                </div>
            </section>
        </section>
        <footer class="group-button text-center">
            <a [routerLink]="['/calculate/step3']" class="btn btn-primary -brand -long">{{language.step2button}}</a>
        </footer>
    </div>
</section>